import CyclojetLogo from "../../assets/Cyclojet.png";
import Ticker from "../common/Ticker";

export default function Footer({ go, certs, db }) {
  return (
    <footer style={{ background: "linear-gradient(180deg,#060f20,#040b17)" }}>
      <Ticker certs={certs || []} />
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "52px 24px 24px", color: "rgba(255,255,255,.65)" }}>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 40, marginBottom: 40 }}
          className="footer-grid">

          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
                <img src={db?.settings?.logoUrl || CyclojetLogo} alt="Cyclojet Logo" style={{ height: 33, objectFit: "cover" }} onError={e => { e.target.onerror = null; e.target.src = CyclojetLogo; }} />
              </div>
              <div />
            </div>
            <p style={{ fontSize: 13.5, lineHeight: 1.8, marginBottom: 13, maxWidth: 280 }}>Multi-service company delivering staffing, software, GC lab instruments and property valuation across India since 2023.</p>
            {[["📍", "Bijnor, UP | New Delhi | Mumbai"], ["📞", "+91-7977779135"], ["✉️", "info@cyclojetinfotech.com"]].map(([ic, tx]) => (
              <div key={tx} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, marginBottom: 6 }}><span style={{ width: 16 }}>{ic}</span><span>{tx}</span></div>
            ))}
          </div>
          {[{ h: "Services", ls: [["staffing", "Staffing Solutions"], ["it", "Software Dev"], ["lab", "Cyclojet Lab"], ["valuation", "Valuation"]] }, { h: "Company", ls: [["blog", "Blog & Insights"], ["careers", "Careers"], ["contact", "Contact Us"]] }, { h: "Legal", ls: [["", "Privacy Policy"], ["", "Terms & Conditions"], ["", "Cookie Policy"]] }].map(col => (
            <div key={col.h}>
              <h4 style={{ color: "#fff", fontWeight: 700, fontSize: 12.5, marginBottom: 13, letterSpacing: .6, textTransform: "uppercase" }}>{col.h}</h4>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 9 }}>
                {col.ls.map(([id2, lb]) => <li key={lb}><span onClick={() => id2 && go(id2)} style={{ fontSize: 13.5, cursor: id2 ? "pointer" : "default", transition: "color .15s" }}>{lb}</span></li>)}
              </ul>
            </div>
          ))}
        </div>
        <div style={{ borderTop: "1px solid rgba(255,255,255,.08)", paddingTop: 18, display: "flex", justifyContent: "space-between", fontSize: 12.5, flexWrap: "wrap", gap: 8, color: "rgba(255,255,255,.5)" }}>
          <span>2026 Cyclojet Infotech Pvt. Ltd. All rights reserved. Est. 2023 · GST: 27AABCC1234F1Z5</span>
          <span>Made with pride in India 🇮🇳</span>
        </div>
      </div>
    </footer>
  );
}
